export default __webpack_public_path__ + "assets/images/pluse-icon-0cb43ef1.svg";